/* Host injection seam for the enterprise-local Agent Memory bundle.
 *
 * ``translationSlot`` 과 같은 패턴이다. 에이전트 메모리 페이지는 enterprise
 * 앱에 있고 (memory-v2 백엔드 API 호출이 host 의존), 공통 라우팅은
 * tenant-neutral 이어야 하므로 host 가 bootstrap 시점에 컴포넌트를 주입한다.
 */

import type React from 'react';

export type MemoryModePageComponent = React.ComponentType;

let modePage: MemoryModePageComponent | null = null;

export function setMemoryModePageComponent(
  component: MemoryModePageComponent | null,
): void {
  modePage = component;
}

export function getMemoryModePageComponent(): MemoryModePageComponent | null {
  return modePage;
}
